(function () {
  'use strict';

  class TrustDifferentiators {
    constructor(el) {
      this.el = el;
      this.scroll = el.querySelector('[data-td-scroll]');

      if (this.scroll) {
        this._attachProgress(this.scroll);
        this._dragScroll(this.scroll);
      }
    }

    _attachProgress(scroll) {
      const wrapper = document.createElement('div');
      wrapper.className = 'td-progress';
      wrapper.innerHTML = '<div class="td-progress__bar"><div class="td-progress__thumb"></div></div>';
      scroll.after(wrapper);

      const thumb = wrapper.querySelector('.td-progress__thumb');
      const bar   = wrapper.querySelector('.td-progress__bar');

      const update = () => {
        const maxScroll = scroll.scrollWidth - scroll.clientWidth;
        if (maxScroll <= 0) { wrapper.style.display = 'none'; return; }
        wrapper.style.display = '';
        const barW   = bar.offsetWidth;
        const ratio  = scroll.clientWidth / scroll.scrollWidth;
        const thumbW = Math.max(20, Math.round(barW * ratio));
        const thumbL = Math.round((barW - thumbW) * (scroll.scrollLeft / maxScroll));
        thumb.style.width = thumbW + 'px';
        thumb.style.left  = thumbL + 'px';
      };

      scroll.addEventListener('scroll', update, { passive: true });
      const ro = new ResizeObserver(update);
      ro.observe(scroll);
      update();
    }

    _dragScroll(el) {
      let active = false, startX, startLeft;
      el.addEventListener('mousedown', e => {
        active = true;
        startX = e.pageX - el.offsetLeft;
        startLeft = el.scrollLeft;
        el.classList.add('is-dragging');
      });
      document.addEventListener('mouseup', () => {
        if (!active) return;
        active = false;
        el.classList.remove('is-dragging');
      });
      el.addEventListener('mousemove', e => {
        if (!active) return;
        e.preventDefault();
        el.scrollLeft = startLeft - (e.pageX - el.offsetLeft - startX) * 1.5;
      });
      el.addEventListener('mouseleave', () => {
        active = false;
        el.classList.remove('is-dragging');
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-td-section]').forEach(el => new TrustDifferentiators(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
